<template>
  <transition name="fade">
    <div v-show="showModal" class="view-wrap">
      <div @click="closeable && closeModal()" class="grey-bg"></div>
      <div :class="size" class="modal-wrap">
        <div class="form-wrap">
          <button v-if="closeable" @click="closeModal()" class="plain close" aria-label="close"></button>
          <div class="form">
            <div class="form-content-holder">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal',
  props: ['closeable', 'size'],
  data () {
    return {
      showModal: false
    }
  },
  created: function () {
    if (this.closeable) {
      window.addEventListener('keydown', this.escape)
    }
  },
  methods: {
    openModal: function () {
      this.showModal = true
      this.$store.dispatch('modalOpen', true)
    },
    closeModal: function () {
      this.showModal = false
      this.$store.dispatch('modalOpen', false)
      this.$emit('closing')
    },
    escape: function (e) {
      if (e.key === 'Escape') {
        this.closeModal()
      }
    }
  },
  destroyed: function () {
    window.removeEventListener('keydown', this.escape)
  }
}
</script>

<style scoped lang="stylus" src="./modal.styl" >



// WEBPACK FOOTER //
// src/components/modal/modal.vue